import type { PlatformId } from "../data/siteContent";

export const DEFAULT_LICENSE_TRACKING_BASE = "https://license.ttrpgplayer.ru/";
const TRACK_DOWNLOAD_CONTENT_TYPE = "text/plain;charset=UTF-8";

function normalizeBaseUrl(base: string): string {
  return base.endsWith("/") ? base : `${base}/`;
}

export function resolveLicenseTrackingBase(): string {
  const fromEnv =
    typeof import.meta.env !== "undefined"
      ? import.meta.env.VITE_LICENSE_TRACKING_URL
      : undefined;
  if (typeof fromEnv === "string" && fromEnv.trim()) {
    return normalizeBaseUrl(fromEnv.trim());
  }
  return DEFAULT_LICENSE_TRACKING_BASE;
}

export function resolveTrackDownloadUrl(base?: string): string {
  return `${normalizeBaseUrl(base ?? resolveLicenseTrackingBase())}v1/track/download`;
}

export function buildTrackDownloadPayload(platform: PlatformId): string {
  return JSON.stringify({ platform });
}

export function trackDownload(platform: PlatformId): void {
  const url = resolveTrackDownloadUrl();
  const body = buildTrackDownloadPayload(platform);

  if (
    typeof navigator !== "undefined" &&
    typeof navigator.sendBeacon === "function"
  ) {
    const blob = new Blob([body], { type: TRACK_DOWNLOAD_CONTENT_TYPE });
    if (navigator.sendBeacon(url, blob)) return;
  }

  if (typeof fetch === "undefined") return;

  void fetch(url, {
    method: "POST",
    headers: { "Content-Type": TRACK_DOWNLOAD_CONTENT_TYPE },
    body,
    keepalive: true,
  }).catch(() => {
    // fire-and-forget: ignore network errors
  });
}
